import { render, staticRenderFns } from "./TableTr.vue?vue&type=template&id=2da8e6e3"
import script from "./TableTr.vue?vue&type=script&lang=js"
export * from "./TableTr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports